module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-litho-finish-limestone-amber.b5466ddc.jpg";